var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "header-picker",
      class: { "is-dark": _vm.dark },
      style: _vm.bgStyle
    },
    [
      !_vm.onlyTime
        ? _c(
            "div",
            { staticClass: "header-picker-year" },
            [
              _c(
                "TransitionGroup",
                { attrs: { name: _vm.transitionName } },
                _vm._l([_vm.year], function(y) {
                  return _c("div", { key: y }, [
                    _vm._v("\n        " + _vm._s(y) + "\n      ")
                  ])
                }),
                0
              )
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      !_vm.range
        ? _c(
            "div",
            { staticClass: "flex justify-content-between" },
            [
              !_vm.onlyTime
                ? _c(
                    "TransitionGroup",
                    {
                      staticClass: "header-picker-date dots-text flex-1",
                      attrs: { name: _vm.transitionName }
                    },
                    _vm._l([_vm.getDateFormatted], function(dateFormatted) {
                      return _c("span", { key: dateFormatted }, [
                        _vm._v(
                          "\n        " +
                            _vm._s(_vm.value ? _vm.getDateFormatted : "...") +
                            "\n      "
                        )
                      ])
                    }),
                    0
                  )
                : _vm._e(),
              _vm._v(" "),
              !_vm.isFormatTwelve && !_vm.noTime && _vm.value
                ? _c(
                    "div",
                    {
                      staticClass: "header-picker-time flex",
                      class: [
                        !_vm.onlyTime
                          ? "pl-10"
                          : "flex-1 justify-content-center"
                      ],
                      style: [_vm.getTimePickerWidth()]
                    },
                    [
                      _c(
                        "TransitionGroup",
                        {
                          staticClass:
                            "dots-text time-number header-picker-hour flex justify-content-right",
                          attrs: { name: _vm.transitionName }
                        },
                        _vm._l([_vm.dateTime.format("HH")], function(hour) {
                          return _c("span", { key: hour }, [
                            _vm._v("\n          " + _vm._s(hour) + "\n        ")
                          ])
                        }),
                        0
                      ),
                      _vm._v(" "),
                      _c("span", [_vm._v(":")]),
                      _vm._v(" "),
                      _c(
                        "TransitionGroup",
                        {
                          staticClass:
                            "dots-text time-number header-picker-minute flex justify-content-left",
                          attrs: { name: _vm.transitionName }
                        },
                        _vm._l([_vm.dateTime.format("mm")], function(min) {
                          return _c("span", { key: min }, [
                            _vm._v("\n          " + _vm._s(min) + "\n        ")
                          ])
                        }),
                        0
                      )
                    ],
                    1
                  )
                : !_vm.noTime && _vm.value
                ? _c(
                    "div",
                    {
                      staticClass: "header-picker-time flex flex-fixed",
                      class: [
                        !_vm.onlyTime
                          ? "pl-10"
                          : "flex-1 justify-content-center"
                      ],
                      style: [_vm.getTimePickerWidth()]
                    },
                    [
                      _c(
                        "TransitionGroup",
                        {
                          staticClass: "dots-text header-picker-hour twelve",
                          attrs: { name: _vm.transitionName }
                        },
                        _vm._l([_vm.dateTime.format(_vm.timeFormat)], function(
                          hour
                        ) {
                          return _c(
                            "span",
                            { key: hour, staticClass: "flex-fixed" },
                            [
                              _vm._v(
                                "\n          " + _vm._s(hour) + "\n        "
                              )
                            ]
                          )
                        }),
                        0
                      )
                    ],
                    1
                  )
                : !_vm.noTime
                ? _c(
                    "div",
                    {
                      staticClass: "header-picker-time flex flex-fixed",
                      class: [
                        !_vm.onlyTime
                          ? "pl-10"
                          : "flex-1 justify-content-center"
                      ],
                      style: [_vm.getTimePickerWidth()]
                    },
                    [_c("span", [_vm._v("...")])]
                  )
                : _vm._e()
            ],
            1
          )
        : _c("div", { staticClass: "flex justify-content-between" }, [
            _c("div", { staticClass: "flex justify-content-between" }, [
              _c(
                "span",
                { staticClass: "header-picker-range dots-text flex-1" },
                [
                  _vm._v(
                    "\n        " +
                      _vm._s(_vm.getRangeDatesFormatted) +
                      "\n      "
                  )
                ]
              )
            ])
          ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }